import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Select from 'src/@vymo/ui/atoms/select';
import { SegmentedTabs } from 'src/@vymo/ui/blocks';
import { useFilterPersistence } from 'src/hooks/useFilterPersistence';
import { getCurrentUser } from 'src/models/lmsConfig/queries';
import { useAppDispatch } from 'src/store/hooks';
import { getUsersList } from 'src/workspace/utils';
import { setFilterData } from '../slice';
import { teamselfFilters } from './constants';
import styles from './index.module.scss';

function HomePageFilter() {
  const [teamSelf, setTeamSelf] = useState('Self');
  const loggedinUser = getCurrentUser();
  const userData = getUsersList('direct_reports');
  const finalUserData = useMemo(
    () => [loggedinUser, ...userData],
    [loggedinUser, userData],
  );
  const [selectedUser, setSelectedUser] = useState(loggedinUser.code);
  const dispatch = useAppDispatch();

  // Handle filter restoration from persistence
  const handleFiltersChange = useCallback(
    (filters: { teamSelf?: string; selectedUser?: string }) => {
      if (filters.teamSelf) {
        setTeamSelf(filters.teamSelf);
      }
      if (filters.selectedUser) {
        const userExists = finalUserData.some(
          (user) => user.code === filters.selectedUser,
        );
        if (userExists) {
          setSelectedUser(filters.selectedUser);
        }
      }
    },
    [finalUserData],
  );

  useFilterPersistence<{
    teamSelf?: string;
    selectedUser?: string;
  }>('homeDashboard', { teamSelf, selectedUser }, handleFiltersChange);

  useEffect(() => {
    const filterData = {
      user: teamSelf,
      user_id: [selectedUser],
    };
    dispatch(setFilterData({ filterData }));
  }, [teamSelf, selectedUser, dispatch]);

  return (
    <div className={styles.filter}>
      <SegmentedTabs
        tabs={teamselfFilters}
        activeTabKey={teamSelf}
        onTabChange={(key) => setTeamSelf(key)}
        tabItemClassName={styles.filter__teamSelfOption}
      />
      <Select
        options={finalUserData}
        value={selectedUser}
        search
        onChange={(value) => setSelectedUser(value[0].code)}
      />
    </div>
  );
}

export default HomePageFilter;
